import { render, staticRenderFns } from "./SectionsSession.vue?vue&type=template&id=368f9e84&scoped=true&"
import script from "./SectionsSession.vue?vue&type=script&lang=js&"
export * from "./SectionsSession.vue?vue&type=script&lang=js&"
import style0 from "./SectionsSession.vue?vue&type=style&index=0&id=368f9e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f9e84",
  null
  
)

export default component.exports